import { Box, Button, Divider, Link, styled, Typography, useTheme } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';
import React from 'react';
import { useTranslation } from 'react-i18next';

const StyledLink = styled(Link)(({ theme }) => ({
  textDecoration: 'none',
  color: theme.palette.primary.main,
  cursor: 'pointer',

  '&:hover': {
    color: theme.palette.primary.dark,
  },
}));

const ClearAll = styled(Typography)(({ theme }) => ({
  color: theme.palette.action.active,
  cursor: 'pointer',
  textAlign: 'right',
}));

type FundAutocompleteMobileProps = {
  areFundsSelected: boolean;
  onClick: () => void;
  onClearAll: () => void;
};

export const FundAutocompleteMobile = ({
  areFundsSelected,
  onClick,
  onClearAll,
}: FundAutocompleteMobileProps) => {
  const { t } = useTranslation();
  const theme = useTheme();

  return areFundsSelected ? (
    <>
      <Divider />
      <Box pt={3} display="flex" justifyContent="space-between" alignItems="center">
        <StyledLink onClick={onClick}>
          <Typography variant="body2">
            {t('cashbackCalculator.detailed.fundAutocomplete.addMore')}
          </Typography>
        </StyledLink>
        <ClearAll variant="body2" onClick={onClearAll}>
          {t('cashbackCalculator.detailed.calculator.clearAll')}
        </ClearAll>
      </Box>
    </>
  ) : (
    <Button
      fullWidth
      variant="text"
      color="primary"
      data-testid="add-fund-mobile"
      startIcon={
        <Box
          color={theme.palette.text.primary}
          height="24px"
          sx={{
            '& svg': {
              width: '24px',
              height: '24px',
            },
          }}
        >
          <AddIcon color="inherit" />
        </Box>
      }
      onClick={onClick}
    >
      {t('cashbackCalculator.detailed.funds.addFund')}
    </Button>
  );
};
